import React, { useEffect, useState } from 'react';
import '../styles/global.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const scrollToMelanges = () => {
    const scroll = () => {
      if (typeof window === 'undefined') return;
      const section = document.getElementById('melanges');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(scroll, 350);
    } else {
      scroll();
    }
    setIsMenuOpen(false);
  };

  const links = [
    { label: 'Idées recettes', to: '/idees-recettes' },
    { label: 'Notre histoire', to: '/notre-histoire' }
  ];

  return (
    <nav className={`nav-shell ${isMenuOpen ? 'nav-shell--open' : ''}`}>
      <div className="container nav-wrapper">
        <div className="nav-header">
          <Link to="/" className="nav-logo" aria-label="Retour à l'accueil KAZA">
            <img
              src="/images/logo-kaza-texte.svg"
              alt="Logo typographique KAZA"
              className="nav-logo-img"
            />
          </Link>

          <button
            type="button"
            className="nav-toggle"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-label="Ouvrir le menu principal"
          >
            <div className="nav-toggle-bars">
              <span />
              <span />
              <span />
            </div>
          </button>
        </div>

        <div className={`nav-links ${isMenuOpen ? 'nav-links--open' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'is-active' : ''}`}
          >
            Accueil
          </Link>
          <button type="button" onClick={scrollToMelanges} className="nav-link nav-link--ghost">
            Nos mélanges
          </button>
          {links.filter(link => link.to !== '/').map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link ${location.pathname === to ? 'is-active' : ''}`}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;